import React, { useState, useEffect } from "react";
import axios from "axios";
import TableOne from "../Table/TableOne"; // Import your table component
import { FaFileUpload } from "react-icons/fa";
import { InputAdornment } from "@mui/material";
import { AiOutlineProject } from "react-icons/ai";
import { MdDelete, MdOutlineLowPriority, MdPreview } from "react-icons/md";
import { BsTextParagraph } from "react-icons/bs";
import Modal from "react-modal";
import "../style/modal.css";
import "./../style/common.css";
import { CiWarning } from "react-icons/ci";
//for modal textfield
import { TextField, MenuItem } from "@mui/material";
//for daterangepicker
import { DateRangePicker } from "react-date-range";
import "react-date-range/dist/styles.css"; // Main CSS file
import "react-date-range/dist/theme/default.css"; // Theme CSS file
// Import locale data
import { enUS } from "date-fns/locale";
import { FaCalendarAlt } from "react-icons/fa";
//daterange
import dayjs from "dayjs";
import { ToastContainer, toast } from "react-toastify";
import {
  Dialog,
  DialogContent,
  DialogActions,
  Button,
  Typography,
} from "@mui/material";

const Project = () => {
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [company, setCompany] = useState([]);
  const [errors, setErrors] = useState({}); //error show state
  const [fileList] = useState([]); // Keep if used in handleSubmit
  const [filteredProject, setFilteredProjects] = useState([]); // For search functionality
  const [showDatePicker, setShowDatePicker] = useState(false); //open calender on click
  const [dateRange, setDateRange] = useState([
    //daterange
    {
      startDate: new Date(),
      endDate: new Date(),
      key: "selection",
    },
  ]);
  // State to store project deletion details
  const [deleteProjectName, setDeleteProjectName] = useState("");
  const [deleteProjectId, setDeleteProjectId] = useState(null);
  const [showDeleteProjectBox, setShowDeleteProjectBox] = useState(false);
  const userRole = localStorage.getItem("role");
  const [DescriptionDialogOpen, setDescriptionDialogOpen] = useState(false);
  const [selectedDescription, setSelectedDescription] = useState("");
  const [openDropdownId, setOpenDropdownId] = useState(null);

  // Close dropdown on outside click
  useEffect(() => {
    const handleClickOutside = () => setOpenDropdownId(null);
    document.addEventListener("click", handleClickOutside);
    return () => document.removeEventListener("click", handleClickOutside);
  }, []);

  //set Data
  const [formData, setFormData] = useState({
    project_company_id: "",
    project_name: "",
    project_description: "",
    project_priority: "",
    project_duration: "",
    project_isstart: "",
    project_iscompleted: "",
    project_isactive: true, //by default set
    project_status: "pending", //by default set
    project_attach_file: "",
  });
  const [editMode, setEditMode] = useState(false); // Edit mode flag

  // Fetch Company data from the API
  const fetchCompany = async () => {
    setLoading(true);
    try {
      const response = await axios.get(
        "/api/company"
      );
      const companyData = response.data.company.map((company) => ({
        CompanyId: company.company_id,
        CompanyName: company.company_name,
      }));
      console.log("company-->", companyData);
      setCompany(companyData);
    } catch (error) {
      console.error("Error fetching company data:", error);
      //   toast.error("Error fetching employee data.");
    }
    setLoading(false);
  };
  useEffect(() => {
    fetchCompany();
  }, []);



  // Fetch Project data from the API
  const fetchProjects = async () => {
    setLoading(true);
    try {
      const projectResponse = await axios.get(
        "/api/projects"
      );
      const companyResponse = await axios.get(
        "/api/company"
      );

      //using reduce fun it's work on reverse num in array
      const companyMap = companyResponse.data.company.reduce((map, company) => {
        map[company.company_id] = company.company_name;
        return map;
      }, {});
      const projectData = projectResponse.data.project.map((pro) => ({
        id: pro.project_id,
        company_id: pro.project_company_id,
        // CompanyName:"Unknown", // Map company ID to name
        CompanyName: companyMap[pro.project_company_id] || "Unknown",
        ProjectName: pro.project_name,
        ProjectDescription: pro.project_description,
        ProjectPriority: pro.project_priority,
        ProjectDuration: pro.project_duration,
        ProjectIsStart: pro.project_isstart,
        ProjectIsCompleted: pro.project_iscompleted,
        ProjectIsActive: pro.project_isactive,
        ProjectStatus: pro.project_status,
        ProjectAttachFile: pro.project_attach_file,
        project_isactive: true,
      }));
      setProjects(projectData);
      setFilteredProjects(projectData); // Initialize filtered data
    } catch (error) {
      console.error("Error fetching project or company data:", error);
    }
    setLoading(false);
  };
  useEffect(() => {
    fetchProjects();
  }, []);

  // Handle file selection
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  //open modal
  const openModal = (project = null) => {
    if (project) {
      setFormData(project);
      // setEditMode(true);
    } else {
      setFormData({
        project_company_id: "",
        project_name: "",
        project_description: "",
        project_priority: "",
        project_duration: "",
        project_isstart: "",
        project_iscompleted: "",
        project_isactive: true, //by default set
        project_status: "pending", //by default set
        project_attach_file: "",
      });
      setEditMode(false);
    }
    // Reset validation errors
    setErrors({});
    setIsModalOpen(true);
  };

  //close the modal
  const closeModal = () => {
    setIsModalOpen(false);
  };

  //date-range
  const handleDateRangeChange = (ranges) => {
    const { selection } = ranges;
    setDateRange([selection]);
    setFormData({
      ...formData,
      project_duration: `${dayjs(selection.startDate).format(
        "DD-MM-YYYY"
      )} - ${dayjs(selection.endDate).format("DD-MM-YYYY")}`, // Save as formatted date range
    });
    console.log("handleDateRangeChange->>", ranges); // Corrected to log ranges
    setShowDatePicker(false); // Hide the date picker after selecting a range
  };

  const toggleDatePicker = () => {
    setShowDatePicker(!showDatePicker); // Toggle date picker visibility
  };

  // Handle Form Submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log("submit--->");

    //Validate the form
    const validateForm = () => {
      const newErrors = {};
      if (!formData.project_company_id) {
        newErrors.project_company_id = "Please Select Company.";
      }
      if (!formData.project_name) {
        newErrors.project_name = "Project name is required.";
      } else if (!editMode) {
        // Only check for duplicates in add mode
        const duplicateProject = projects.find(
          (p) =>
            p.ProjectName.toLowerCase() === formData.project_name.toLowerCase()
        );

        if (duplicateProject) {
          newErrors.project_name = "Project name already exists!";
        }
      }
      if (!formData.project_duration) {
        newErrors.project_duration = "Duratation is required.";
      }
      if (!formData.project_priority) {
        newErrors.project_priority = "Please Select Priority.";
      }
      return newErrors;
    };
    const errors = validateForm();
    if (Object.keys(errors).length > 0) {
      setErrors(errors); // Set errors in state for display
      return; // Stop the submission
    }
    try {
      const url = editMode
        ? `/api/project/update/${formData.project_id}`
        : "/api/project/add";

      const method = editMode ? "put" : "post";
      const formDataToSend = new FormData();
      Object.keys(formData).forEach((key) => {
        formDataToSend.append(key, formData);
      });
      if (fileList.length > 0) {
        formDataToSend.append("project_attach_file", fileList[0]);
      }

      const user = JSON.parse(localStorage.getItem("user")) || {};
      const userProfile = JSON.parse(localStorage.getItem("userProfile")) || {};
      let updatedByName = "Unknown";
      if (user.role === "manager") {
        updatedByName = `${userProfile.employee_first_name || ""} ${userProfile.employee_last_name || ""}`.trim() || "Manager";
      }

      const payload = {
        ...formData,
        updated_by_role: user.role,
        updated_by_name: updatedByName,
        updated_by_id: user.id
      };

      await axios({
        method,
        url,
        data: payload,
      });
      toast.success(
        editMode
          ? "Project updated successfully!"
          : "Project added successfully!"
      );
      fetchProjects(); // Refresh data
      closeModal();
      setErrors({}); // Clear errors after successful submission
    } catch (error) {
      console.error("Error submitting data:", error);
      toast.error("Failed to submit data. Please try again.");
    }
  };

  //edit
  const handleEdit = (pro) => {
    // Find the latest project details before editing
    const latestProject = projects.find((p) => p.id === pro.id);

    setFormData({
      project_id: latestProject?.id || "",
      project_company_id: latestProject?.company_id || "",
      project_name: latestProject?.ProjectName || "",
      project_description: latestProject?.ProjectDescription || "",
      project_priority: latestProject?.ProjectPriority || "",
      project_duration: latestProject?.ProjectDuration || "",
      project_isstart: latestProject?.ProjectIsStart || "",
      project_iscompleted: latestProject?.ProjectIsCompleted || "",
      project_isactive: true,
      project_status: latestProject?.ProjectStatus || "", // Fetch latest status
      project_attach_file: latestProject?.ProjectAttachFile || "",
    });
    setEditMode(true); // Enable edit mode
    setIsModalOpen(true); // Open modal with updated data
  };


  //delete
  const handleDelete = async (pro) => {
    const project_id = pro.id;
    const project_name = pro.ProjectName || "Unnamed Project"; // You can change this according to your field
    if (!project_id) {
      toast.error("Invalid project ID. Please try again.");
      return;
    }
    // Set the project name and ID to state before showing the pop-up
    setDeleteProjectName(project_name);
    setDeleteProjectId(project_id);
    setShowDeleteProjectBox(true); // Show the custom confirmation box
  };
  const confirmDeleteProject = async () => {
    if (!deleteProjectId) return;
    try {
      const response = await axios.delete(
        `/api/project/delete/${deleteProjectId}`
      );
      if (response.status === 200) {
        toast.success("Project deleted successfully!");
        const updatedProjects = projects.filter(
          (item) => item.id !== deleteProjectId
        );
        setProjects(updatedProjects); // Update the projects state after deleting the project
        setFilteredProjects(updatedProjects); // Ensure filtered list is updated
      }
      setShowDeleteProjectBox(false); // Close the confirmation box
    } catch (error) {
      console.error("Error deleting Project:", error);
      toast.error("An error occurred while deleting the Project.");
      setShowDeleteProjectBox(false); // Close the box on error
    }
  };
  const cancelDeleteProject = () => {
    setShowDeleteProjectBox(false); // Close the confirmation box
  };

  //for project fle upload
  const handleFileUpload = async (id, file) => {
    if (!file) {
      toast.error("Please select a file.");
      return;
    }
    const formData = new FormData();
    formData.append("project_attach_file", file);
    setLoading(true);
    try {
      const response = await axios.post(
        `/api/project/add-attachment/${id}`,
        formData,
        {
          headers: { "Content-Type": "multipart/form-data" },
        }
      );
      if (response.status === 200 || response.status === 201) {
        toast.success("File uploaded successfully!");
        fetchProjects(); // Refresh project after upload
      } else {
        toast.error("Failed to upload file.");
      }
    } catch (error) {
      console.error("File upload error:", error);
      toast.error("File Type Must Be: pdf, doc, docx, xlsx, csv, txt, png, jpg, jpeg");
    }
  };
  const handleFileDelete = async (pro) => {
    const project_id = pro.id;
    if (!project_id) {
      toast.error("Invalid project ID. Please try again.");
      return;
    }
    const confirmed = window.confirm(
      "Are you sure you want to delete this Project File?"
    );
    if (!confirmed) return;
    try {
      const response = await axios.delete(
        `/api/project/delete-attachment/${project_id}`
      );
      console.log("response", response);
      if (response.status === 200) {
        // Remove the deleted projects from the state
        toast.success("Project File deleted successfully!");
        console.log("success delete");
        fetchProjects();
      }
    } catch (error) {
      console.error("Error deleting Project File :", error);
      toast.error("An error occurred while deleting the Project File.");
    }
  };
  // Function to handle status update
  const handleStatusChange = async (id, newStatus) => {
    if (!newStatus) {
      toast.error("Invalid status update");
      return;
    }
    try {
      const response = await axios.put(
        `/api/projects/${id}/status`,
        { project_status: newStatus },
        { headers: { "Content-Type": "application/json" } }
      );

      if (response.status === 200) {
        toast.success(`Project marked as ${newStatus}`);
        // Update projects state properly
        setProjects((prevProjects) =>
          prevProjects.map((proj) =>
            proj.id === id ? { ...proj, ProjectStatus: newStatus } : proj
          )
        );
        setFilteredProjects((prevFiltered) =>
          prevFiltered.map((proj) =>
            proj.id === id ? { ...proj, ProjectStatus: newStatus } : proj
          )
        );
      } else {
        toast.error("Failed to update task status.");
      }
    } catch (error) {
      console.error("Error updating task status:", error);
      toast.error("Error updating task status.");
    }
  };


  // Table columns
  const columns = [
    { Header: "Sr.No", accessor: (row, index) => index + 1, id: "index" },
    { Header: "Company", accessor: "CompanyName" }, // Display company name
    { Header: "Project", accessor: "ProjectName" },
    {
      Header: "Description",
      accessor: "ProjectDescription",
      className: "table-cell capitalize-text",
      Cell: ({ row }) => {
        const fullDescription = `${row.original.ProjectDescription}`;
        const truncatedDescription =
          fullDescription.length > 15
            ? `${fullDescription.substring(0, 15)}...`
            : fullDescription;
        return (
          <>
            <span>{truncatedDescription}</span>
            {fullDescription.length > 15 && (
              <Button
                size="small"
                color="primary"
                onClick={() => {
                  setSelectedDescription(fullDescription);
                  setDescriptionDialogOpen(true);
                }}
              >
                Read More
              </Button>
            )}
          </>
        );
      },
    },
    {
      Header: "Priority",
      accessor: "ProjectPriority",
      Cell: ({ value }) => (
        <span
          style={{
            color:
              value === "High"
                ? "#e74c3c"
                : value === "Medium"
                  ? "#f39c12"
                  : value === "Low"
                    ? "#27ae60"
                    : "black", // Default color
            fontWeight: "bold",
          }}
        >
          {value}
        </span>
      ),
    },
    { Header: "Duration", accessor: "ProjectDuration" },
    {
      Header: "Status",
      accessor: "ProjectStatus",
      Cell: ({ row }) => {
        const isOpen = openDropdownId === row.original.id;
        const userRole = localStorage.getItem("role");
        const handleDropdownChange = async (newStatus) => {
          await handleStatusChange(row.original.id, newStatus);
          setOpenDropdownId(null);
        };

        return (
          <div
            style={{
              position: "relative",
              cursor: userRole === "manager" ? "not-allowed" : "pointer",
            }}
            onClick={(e) => {
              e.stopPropagation();
              if (userRole !== "manager") setOpenDropdownId(isOpen ? null : row.original.id);
            }}
          >
            <span
              className="status-badge"
              style={{
                color: "white",
                background:
                  row.original.ProjectStatus === "Pending"
                    ? "#ff4d4d"
                    : row.original.ProjectStatus === "Ongoing"
                      ? "#ffa500"
                      : row.original.ProjectStatus === "InReview"
                        ? "#3b82f6"
                        : row.original.ProjectStatus === "Completed"
                          ? "#2ecc71"
                          : "#ff4d4d",
                fontWeight: "700",
                borderRadius: "8px",
                padding: "6px 12px",
                fontSize: "12px",
                boxShadow: "0 4px 10px rgba(0,0,0,0.2)",
                opacity: userRole === "manager" ? 0.6 : 1,
                transition: "all 0.3s ease"
              }}
            >
              {row.original.ProjectStatus}
            </span>

            {isOpen && userRole !== "manager" && (
              <div
                className="dropdown-menu"
                style={{
                  position: "absolute",
                  background: "var(--bg-card)",
                  backdropFilter: "blur(10px)",
                  border: "1px solid var(--border)",
                  padding: "8px",
                  left: "100%",
                  ...(row.rowIndexInPage < row.currentPageSize / 2 ? { top: "0" } : { bottom: "0" }),
                  marginLeft: "12px",
                  borderRadius: "12px",
                  boxShadow: "0px 10px 30px rgba(0,0,0,0.5)",
                  zIndex: 999,
                  minWidth: "120px"
                }}
              >
                {["Pending", "Ongoing", "InReview", "Completed"].map((option) => (
                  <div
                    key={option}
                    style={{
                      padding: "8px 12px",
                      cursor: "pointer",
                      borderRadius: "6px",
                      color: "var(--text-main)",
                      fontSize: "13px",
                      fontWeight: "500",
                      background: option === row.original.ProjectStatus ? "rgba(255,255,255,0.1)" : "transparent",
                      transition: "all 0.2s ease"
                    }}
                    onMouseEnter={(e) => e.target.style.background = "rgba(255,255,255,0.1)"}
                    onMouseLeave={(e) => e.target.style.background = option === row.original.ProjectStatus ? "rgba(255,255,255,0.1)" : "transparent"}
                    onClick={(e) => {
                      e.stopPropagation();
                      handleDropdownChange(option);
                    }}
                  >
                    {option}
                  </div>
                ))}
              </div>
            )}
          </div>
        );
      },
    },

    {
      Header: "File",
      accessor: "ProjectAttachFile",
      Cell: ({ row }) => {
        const [isHovered, setIsHovered] = useState(false);
        const hasFile = !!row.original.ProjectAttachFile;

        // Get user role from localStorage
        const userRole = localStorage.getItem("role");

        return (
          <div
            className="file-cell"
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
          >
            {!hasFile ? (
              // Show Upload option only for Admins
              userRole === "admin" && (
                <>
                  <label
                    htmlFor={`file-upload-${row.original.id}`}
                    className="file-upload-label"
                  >
                    <FaFileUpload className="file-icon" />
                  </label>
                  <input
                    type="file"
                    id={`file-upload-${row.original.id}`}
                    style={{ display: "none" }}
                    onChange={(e) =>
                      handleFileUpload(row.original.id, e.target.files[0])
                    }
                  />
                </>
              )
            ) : (
              <>
                <MdPreview className="file-icon" />
                {isHovered && (
                  <div className="file-hover-options">
                    {/* Preview Button (Visible for all roles) */}
                    <a
                      href={row.original.ProjectAttachFile}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="file-option"
                    >
                      <MdPreview className="file-icon" />
                      Preview
                    </a>

                    {/* Delete Button (Only for Admins) */}
                    {userRole === "admin" && (
                      <button
                        onClick={() => handleFileDelete(row.original)}
                        className="file-delete-button"
                      >
                        <MdDelete className="file-icon" />
                        Delete
                      </button>
                    )}
                  </div>
                )}
              </>
            )}
          </div>
        );
      },
    },
  ];
  const hasAccess = (allowedRoles) => {
    const userRole = localStorage.getItem("role");
    return allowedRoles.includes(userRole);
  };
  return (
    <div>
      <ToastContainer />
      <div
        className="page-head"
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          fontSize: "10px",
          marginLeft: "1%",
          marginRight: "2%",
        }}
      >
        <h1>
          <AiOutlineProject /> Project
        </h1>
        {hasAccess(["admin"]) && (
          <button className="add-button" onClick={() => openModal()}>
            + Add
          </button>
        )}
      </div>

      {loading ? (
        <div className="loader-container">
          <div className="loader"></div>
          <p>Loading...</p>
        </div>
      ) : (
        <TableOne
          columns={columns}
          data={filteredProject.slice().reverse()}
          handleEdit={handleEdit}
          handleDelete={handleDelete}
          isDeleteAction={userRole !== "manager"}
          isEditAction={true}
          userRole={userRole}
        />
      )}

      {/* Address */}
      <Dialog
        open={DescriptionDialogOpen}
        onClose={() => setDescriptionDialogOpen(false)}
      >
        <DialogContent>
          <Typography variant="h6">Description</Typography>
          <Typography variant="body2">{selectedDescription}</Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setDescriptionDialogOpen(false)}>Close</Button>
        </DialogActions>
      </Dialog>

      {showDeleteProjectBox && (
        <div className="popup-overlay">
          <div className="popup-box">
            <div className="popup-header">
              <CiWarning /> Confirm Delete
            </div>
            <div className="popup-message">
              Are you sure you want to delete the project{" "}
              <span className="project-name">
                <strong>{deleteProjectName}</strong>
              </span>{" "}
              from the system?
            </div>
            <div className="popup-buttons">
              <button className="confirm-button" onClick={confirmDeleteProject}>
                Yes, Delete
              </button>
              <button className="cancel-button" onClick={cancelDeleteProject}>
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
      <Modal
        isOpen={isModalOpen}
        onRequestClose={closeModal}
        contentLabel="Project Form"
        className="add-project-modal"
        shouldCloseOnOverlayClick={false} //other click on screen, never close form
        style={{
          content: {
            width: "400px",
          },
        }}
      >
        <h2>{editMode ? "Edit Project" : "Add Project"}</h2>

        <form className="project-form" onSubmit={handleSubmit}>
          <div className="form-container">
            {/* Row 1 */}
            <div className="form-row">
              <div className="form-field">
                {/* <label>Company Name</label> */}

                <TextField
                  select
                  label="Company"
                  name="project_company_id"
                  value={formData.project_company_id}
                  error={!!errors.project_company_id}
                  helperText={errors.project_company_id}
                  onChange={handleInputChange}
                  // disabled={editMode} // Disable when editing
                  fullWidth
                  style={{ width: "190px" }}
                >
                  {/* <MenuItem value="">Select Company</MenuItem> */}
                  {company.map((companyData) => (
                    <MenuItem
                      key={companyData.CompanyId}
                      value={companyData.CompanyId}
                    >
                      {companyData.CompanyName}
                    </MenuItem>
                  ))}
                </TextField>
              </div>
              <div className="form-field">
                <TextField
                  label="Project Name"
                  name="project_name"
                  // disabled={editMode} // Disable when editing
                  value={formData.project_name}
                  error={!!errors.project_name}
                  helperText={errors.project_name}
                  onChange={handleInputChange}
                  fullWidth
                  InputProps={{
                    startAdornment: (
                      <InputAdornment
                        position="start"
                        style={{ color: "black" }}
                      >
                        <AiOutlineProject />
                      </InputAdornment>
                    ),
                  }}
                />
              </div>
            </div>
            {/* Row 2 */}
            <div className="form-row">
              <div className="form-field">
                {/* Input Field with Calendar Icon */}
                <TextField
                  label="Project Duration"
                  name="project_duration"
                  value={formData.project_duration}
                  error={!!errors.project_duration}
                  helperText={errors.project_duration}
                  onClick={toggleDatePicker} // Open date picker on click
                  fullWidth
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <FaCalendarAlt
                          onClick={toggleDatePicker}
                          style={{ cursor: "pointer" }}
                        />
                      </InputAdornment>
                    ),
                  }}
                  readOnly // Make the input field readonly
                />
              </div>
              {/* Conditional Rendering of DateRangePicker */}
              {showDatePicker && (
                <div
                  className="project-calendar-responsive-container"
                  style={{
                    position: "absolute",
                    left: "415px",
                    top: "50%",
                    transform: "translateY(-50%)",
                    zIndex: 999
                  }}
                >
                  <DateRangePicker
                    ranges={dateRange}
                    onChange={handleDateRangeChange}
                    locale={enUS}
                    moveRangeOnFirstSelection={false}
                  />
                </div>
              )}
            </div>

            {/* Row 3 */}
            <div className="form-row">
              <div className="form-field">
                <TextField
                  select
                  label="Project Priority"
                  name="project_priority"
                  value={formData.project_priority}
                  error={!!errors.project_priority}
                  helperText={errors.project_priority}
                  onChange={handleInputChange}
                  fullWidth
                  InputProps={{
                    startAdornment: (
                      <InputAdornment
                        position="start"
                        style={{ color: "black" }}
                      >
                        <MdOutlineLowPriority />
                      </InputAdornment>
                    ),
                  }}
                >
                  <MenuItem value="">Select Priority</MenuItem>
                  <MenuItem value="High">High</MenuItem>
                  <MenuItem value="Medium">Medium</MenuItem>
                  <MenuItem value="Low">Low</MenuItem>
                </TextField>
              </div>
            </div>
            <div className="form-field">
              <TextField
                label="Project Description"
                name="project_description"
                id="outlined-textarea"
                value={formData.project_description}
                onChange={handleInputChange}
                fullWidth
                multiline
                rows={1} // You can adjust the number of rows as needed
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start" style={{ color: "black" }}>
                      <BsTextParagraph />
                    </InputAdornment>
                  ),
                }}
              />
            </div>
            {/* Actions */}
            <div className="form-actions">
              <button variant="contained" color="primary" type="submit">
                {editMode ? "Save" : "+Add"}
              </button>
              <button
                variant="outlined"
                onClick={closeModal}
                className="close-button"
              >
                Cancel
              </button>
            </div>
          </div>
        </form>
      </Modal>
    </div>
  );
};
export default Project;
